import { RoutePath } from 'src/data/Routes';
import type { ToolSection } from 'src/routing/RouteToolSections';

export const CHANGE_TRACKER_SECTIONS = [
  { key: 'change-tracker-changes', path: '/changes', title: 'Changes', isLeaf: true },
  { key: 'change-tracker-filters', path: '/filters', title: 'Filters', isLeaf: true },
  { key: 'change-tracker-options', path: '/options', title: 'Options', isLeaf: true },
] as const satisfies readonly ToolSection[];

export type ChangeTrackerSectionPath = typeof CHANGE_TRACKER_SECTIONS[number]['path'];

export const CHANGE_TRACKER_SECTION_DEFAULT = RoutePath.EVENTS + CHANGE_TRACKER_SECTIONS[0].path;
